import { createSSRApp } from 'vue';
import App from './App.vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { ensureSafeAreaPolyfill } from './utils/safeArea';
// css
import 'uno.css';
if (typeof window !== 'undefined' && typeof window.__f__ !== 'function') {
	window.__f__ = function __f__() {};
}

ensureSafeAreaPolyfill();

export function createApp() {
	const app = createSSRApp(App);
	const pinia = createPinia();
	pinia.use(piniaPluginPersistedstate);
	app.use(pinia);
	return {
		app,
		pinia
	};
}
